// utils
import { generateRandomCode } from 'app/utils';

function formatProfessionCallback(professionIndication) {
  const { id, formAddOn } = professionIndication;

  return {
    ...professionIndication,
    formAddOn: {
      ...formAddOn,
      hasError: false,
      professionIndicationId: id,
      randomCode: generateRandomCode()
    }
  };
}

export { formatProfessionCallback };
